export EntityForm from './EntityForm';



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/entity/components/index.js